import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=3952c168"
import script from "./TheLoader.vue?vue&type=script&lang=ts"
export * from "./TheLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports